/**
 * What the frame of the application is built from: the kit's bars, and the device
 * the window is. Like everything in this folder, it is the kit under the
 * application's roof: nothing outside shared/ui imports @easymusic/ui.
 */
import { deviceForWidth, type Device } from '@easymusic/ui';
import { useEffect, useState } from 'react';

export {
  BottomTabBar,
  Footer,
  Icon,
  IconButton,
  SideNav,
  TopBar,
  type Device,
  type FooterLink,
  type IconName,
  type SideNavItem,
  type TabItem,
  type TopBarLink,
} from '@easymusic/ui';

/**
 * The device the window is, by the kit's breakpoints. For the few places where a
 * device gets different markup, not only different sizes (the kit's styles do the latter).
 */
export function useDevice(): Device {
  const [device, setDevice] = useState<Device>(() => deviceForWidth(window.innerWidth));
  useEffect(() => {
    const update = () => setDevice(deviceForWidth(window.innerWidth));
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);
  return device;
}
